import CaseStudyCard from './CaseStudyCard';

export default CaseStudyCard;
